import type { SolverStrategy, StrategyInput, StrategyOutput } from '../types';
import type { TileStackModel } from '../../boardMVC/models/board/TileStackModel';
import type { TileColor } from '../../boardMVC/TileColor';
import { SolverRandomStrategy } from './SolverRandomStrategy';
import MathUtils from '../../../utils/MathUtils';

export class StrategyMakeMatch implements SolverStrategy {
  public readonly label = 'match';

  private readonly randomStrategyFallback = new SolverRandomStrategy();

  public getNextMove(input: StrategyInput): StrategyOutput {
    const { boardModel, trayModel } = input;

    const possibleColors = trayModel.getTopColors();

    const candidates = boardModel
      .getEmptyStacks()
      .map((stack) =>
        possibleColors.map((color) => {
          const connections = stack.getMatchingConnections(color, (s) => s.isBlocked());
          return connections.length > 0 ? { stack, color } : null;
        }),
      )
      .flat()
      .filter((v): v is { stack: TileStackModel; color: TileColor } => v !== null);

    if (candidates.length === 0) return this.randomStrategyFallback.getNextMove(input);

    const finalCandidate = MathUtils.rnd.pick(candidates);

    return {
      fromStack: possibleColors.indexOf(finalCandidate.color),
      toStack: { x: finalCandidate.stack.x, y: finalCandidate.stack.y },
    };
  }
}
